import SearchPage from "src/components/pages/search/search-page";
import { createSearchServerSideProps } from "src/components/pages/search/utils/create-search-server-side-props";
import { LANGUAGE } from "src/constants/locale";

export const getServerSideProps = createSearchServerSideProps(LANGUAGE.DE);

export default SearchPage;
